import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../../../../selectors';
import * as appActions from '../../../../actions';
import Quiz from './Quiz.component';

const QuizContainer = props => <Quiz {...props} />;

const mapStateToProps = state => ({
	winners: apiSelectors.quiz.latestQuizWinnersSelector(state),
	activeQuestion: appSelectors.ui.latestActiveQuestionSelector(state),
	doneQuestion: appSelectors.ui.latestDoneQuestionSelector(state),
});

const mapDispatchToProps = dispatch => ({
	questionDone: bindActionCreators(appActions.ui.uiActions.questionDone, dispatch),
});

QuizContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(QuizContainer);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/quiz/Quiz.container.js